import {
  animate,
  style,
  transition,
  trigger,
  type AnimationTriggerMetadata,
} from '@angular/animations';

const from = style({ opacity: 0 });
const to = style({ opacity: 1 });

export function appear(
  inTiming: number = 300,
  outTiming: number = 300,
): AnimationTriggerMetadata {
  return trigger('appear', [
    transition(':enter', [from, animate(inTiming + 'ms', to)]),
    transition(':leave', [to, animate(outTiming + 'ms', from)]),
  ]);
}

export function appearTrigger(
  inTiming: number = 300,
  outTiming: number = 300,
): AnimationTriggerMetadata {
  return trigger('appearTrigger', [
    transition('* => open', [from, animate(inTiming + 'ms', to)]),
    transition('* => close', [to, animate(outTiming + 'ms', from)]),
  ]);
}
